export class SubmitProgressReportContributorData {
    progressReportSk: string;
    progressMeasurementSk: string;
    mandateSK: string;
    annualGoalSeq: number;
    personSK: string;
    role: number;
    lastModuser: string;
    lastModTS: Date;
    personName: string;
    firstName: string;
    lastName: string;
    middleName: string;
    email: string;
    phone: string;
    title: string;
    operationType: number;

    constructor(contributorData: any) {
        this.progressReportSk = contributorData.progressReportSk;
        this.progressMeasurementSk = contributorData.progressMeasurementSk;
        this.mandateSK = contributorData.mandateSK;
        this.annualGoalSeq = contributorData.annualGoalSeq;
        this.personSK = contributorData.personSK;
        this.role = contributorData.role;
        this.lastModuser = contributorData.lastModuser;
        this.lastModTS = contributorData.lastModTS;
        this.personName = contributorData.personName;
        this.firstName = contributorData.firstName;
        this.lastName = contributorData.lastName;
        this.middleName = contributorData.middleName;
        this.email = contributorData.email;
        this.phone = contributorData.phone;
        this.title = contributorData.title;
        this.operationType = contributorData.operationType;
    }
}